import 'whatwg-fetch';

import {init as initFacebook} from './components/facebook';
import {init as initGoogle} from './components/google';
import {init as initSnap} from './components/snap';
import {noop} from './shared/util';

import './_debug';

initSnap().catch(noop);
initGoogle().catch(noop);
initFacebook().catch(noop);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main.ts